module.exports = __webpack_public_path__ + "static/top_banner-3d8d2fbdccd7ad2271b5dfcac7191a11.png";